import React from "react";
import { useMediaQuery } from "react-responsive";
import "../css/EventAgenda.css";
import { useNavigate } from "react-router-dom";
import { eventIcons } from "../../_helper/constant/constant";
import CuSpinner from "../../../common_component/component/CuSpinner";
import Popup from "reactjs-popup";
import { getOrdinalSuffix } from "../../../_helper/utils/utils";
import { IoEllipse } from "react-icons/io5";
import { checkPermission } from "../../../roles_and_permissions/_features";

export const Appointment_Icons = {
  O: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+166+%281%29.png",
  N: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+166+%282%29.png",
  NF: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+166+%283%29.png",
  OF: "https://cufront-assets.s3.amazonaws.com/icons+/Frame+166+%284%29.png",
  Search: "https://cufront-assets.s3.amazonaws.com/icons+/Vector+%281%29.png",
  BookAppointment:
    "https://cufront-assets.s3.amazonaws.com/icons+/Mask+group.png",
  NoShow: "https://cufront-assets.s3.amazonaws.com/icons+/no-show.png",
  blocked: "https://cufront-assets.s3.amazonaws.com/icons+/blocked.png",
  continue_consultation:
    "https://cufront-assets.s3.amazonaws.com/icons+/continue_consultation.png",
  invoice: "https://cufront-assets.s3.amazonaws.com/Vector+(1).png",
  book_appointment:
    "https://cufront-assets.s3.amazonaws.com/icons+/book_appointment.png",
  unblock: "https://cufront-assets.s3.amazonaws.com/icons+/unblocked.png",
  restart_consultation:
    "https://cufront-assets.s3.amazonaws.com/icons+/Vector+(3).png",
  invoice_paid: "https://cufront-assets.s3.amazonaws.com/Frame+487.png",
  invoice_pending: "https://cufront-assets.s3.amazonaws.com/Frame+488.png",
};

const Events = React.memo((event) => {
  const {
    dayCycle,
    handleBlock,
    handleUnBlock,
    handleEditPatient,
    handleDecline,
    handleReschedule,
    handlePreConsultation,
    setIsPreconsultation,
    handleStartConsultation,
    handleEndConsultation,
    handleOpenSlotClick,
    handleNoShow,
    handleCreateInvoice,
    setIsMobileModal,
    isConsultationLoading,
    clinic_id,
    allClinic,
    permission,
  } = event;

  const navigate = useNavigate();

  const openModal = (event) => {
    setIsMobileModal({ flag: true, event: event });
  };

  const sm = !useMediaQuery({ query: "(min-width:1024px)" });

  const event_border_colors = {
    booked: event?.event?.is_walk_in ? "blue" : "gray",
    blocked: "red",
    Open: "green",
    completed: "black",
    no_show: "orange",
    video_consultation: "purple",
  };

  const borderColor =
    event_border_colors[event?.title === "no_show" ? "no_show" : event?.title];

  let user_status;

  if (Appointment_Icons[`${event?.event?.patient}`] != undefined) {
    user_status = Appointment_Icons[`${event?.event?.patient}`];
  }

  const handleMainSearch = (val) => {
    navigate(`/new/patient-options?&all_clinic=${allClinic}&userId=${val}`);
  };

  let invoice_icon = Appointment_Icons.invoice;
  let invoiceTip = "";
  if (event?.event?.billing_status?.billing_status === "pending") {
    invoice_icon = Appointment_Icons.invoice_pending;
    invoiceTip = "Pending";
  }

  if (event?.event?.billing_status?.billing_status === "paid") {
    invoice_icon = Appointment_Icons.invoice_paid;
    invoiceTip = "Paid";
  }

  if (event?.event?.billing_status?.billing_status === "invoice not created") {
    invoice_icon = Appointment_Icons.invoice;
    invoiceTip = "Create Invoice";
  }

  if (event?.event?.billing_status?.billing_status === "partially paid") {
    invoice_icon = Appointment_Icons.invoice_pending;
    invoiceTip = "Partially Paid";
  }

  console.log(event);

  return (
    <>
      {event?.event?.title === "open" ? (
        <div
          id="open-block-event-container"
          style={{ border: `1.5px solid ${borderColor}` }}
        >
          <p
            onClick={() => handleOpenSlotClick(event?.event)}
            className="sm:ml-[29px] lg:text-base xl:text-lg xlarge:text-xl"
          >
            {event.event.title == "open" && "Open"}
          </p>

          {sm ? (
            <div>
              <span onClick={(e) => handleBlock(e, event?.event)}>
                <img
                  style={{ width: "1.2rem" }}
                  src={Appointment_Icons["blocked"]}
                />
              </span>
            </div>
          ) : (
            <>
              <div
                style={{
                  marginLeft: "auto",
                  width: "fit-content",
                }}
                className="icons sm:mr-[29px]"
              >
                <span onClick={(e) => handleBlock(e, event?.event)}>
                  <img
                    style={{ width: "1.2rem" }}
                    src={Appointment_Icons["blocked"]}
                  />
                </span>
              </div>
            </>
          )}
        </div>
      ) : event?.event?.title === "no_show" ||
        event?.event?.title === "completed" ? (
        <>
          <div
            id="open-block-event-container"
            style={{ border: `1.5px solid ${borderColor}` }}
          >
            <p
              className={`${
                dayCycle == "week"
                  ? "font-semibold lg:text-base xl:text-lg xlarge:text-xl"
                  : "sm:ml-[95px] font-semibold lg:text-base xl:text-lg xlarge:text-xl whitespace-nowrap overflow-hidden text-ellipsis"
              }`}
            >
              {event?.event?.user_details?.full_name}
              <span className="ml-2 lg:text-base xl:text-lg xlarge:text-xl">
                {event?.event?.user_details?.age}
              </span>
              <span className="ml-2 lg:text-base xl:text-lg xlarge:text-xl">
                {event?.event?.user_details?.gender?.length > 0
                  ? event?.event?.user_details?.gender[0]
                  : ""}
              </span>
            </p>
            {/* <p
              className={`${
                dayCycle == "week"
                  ? "font-semibold lg:text-base xl:text-lg xlarge:text-xl"
                  : "sm:ml-[95px] font-semibold lg:text-base xl:text-lg xlarge:text-xl"
              }`}
            >
              {event?.event?.user_details?.age}

       
            </p>

            <p
              className={`${
                dayCycle == "week"
                  ? "font-semibold lg:text-base xl:text-lg xlarge:text-xl"
                  : "sm:ml-[95px] font-semibold lg:text-base xl:text-lg xlarge:text-xl"
              }`}
            >
              {event?.event?.user_details?.gender}
            </p> */}

            {(dayCycle == "day" || dayCycle == "agenda") && (
              <div style={{ display: "flex", gap: "12px" }}>
                {(event?.event?.title === "completed" ||
                  event?.event?.title === "no_show") && (
                  <>
                    {event?.event?.title === "completed" && (
                      <>
                        <Popup
                          trigger={
                            <span
                              className="md:text-base lg:text-base 2xl:text-lg"
                              onClick={() =>
                                handleCreateInvoice("OPD", event?.event)
                              }
                            >
                              <img
                                src={invoice_icon}
                                alt="..."
                                width="14px"
                                height="15px"
                              />
                            </span>
                          }
                          position="top center"
                          on="hover"
                          contentStyle={{
                            padding: "5px 10px",
                            width: "fit-content",
                            backgroundColor: "black",
                            color: "white",
                          }}
                          arrowStyle={{ color: "black" }}
                          arrow={true}
                        >
                          <div>{invoiceTip}</div>
                        </Popup>
                        <Popup
                          content="Restart Consultation"
                          inverted
                          trigger={
                            <span
                              className="md:text-base lg:text-base 2xl:text-lg"
                              onClick={() =>
                                handleStartConsultation(event?.event)
                              }
                            >
                              {(dayCycle === "day" || dayCycle === "agenda") &&
                              isConsultationLoading ? (
                                <CuSpinner />
                              ) : (
                                eventIcons?.restart
                              )}
                            </span>
                          }
                          position="top center"
                          on="hover"
                          contentStyle={{
                            padding: "8px 15px",
                            border: "none",
                            width: "fit-content",
                            backgroundColor: "black",
                            color: "white",
                          }}
                          arrowStyle={{ color: "black" }}
                          arrow={true}
                        >
                          <div>Restart Consultation</div>
                        </Popup>
                      </>
                    )}

                    <Popup
                      inverted
                      trigger={
                        <span
                          className="md:text-base lg:text-base 2xl:text-lg"
                          onClick={() =>
                            handleMainSearch(event?.event?.user_details?.id)
                          }
                        >
                          {eventIcons?.viewProfile}
                        </span>
                      }
                      position="top center"
                      on="hover"
                      contentStyle={{
                        padding: "8px 15px",
                        border: "none",
                        width: "fit-content",
                        backgroundColor: "black",
                        color: "white",
                      }}
                      arrowStyle={{ color: "black" }}
                      arrow={true}
                    >
                      <div>View Profile</div>
                    </Popup>

                    <Popup
                      trigger={
                        <a
                          href={`tel:${event?.event?.user_details?.phone}`}
                          className=""
                        >
                          <span className="md:text-base lg:text-base 2xl:text-lg">
                            {eventIcons?.call}{" "}
                          </span>
                        </a>
                      }
                      position="top center"
                      on="hover"
                      contentStyle={{
                        padding: "8px 15px",
                        border: "none",
                        width: "fit-content",
                        backgroundColor: "black",
                        color: "white",
                      }}
                      arrowStyle={{ color: "black" }}
                      arrow={true}
                    >
                      <div>Call Patient</div>
                    </Popup>
                  </>
                )}
                <p
                  className={`${
                    dayCycle == "week"
                      ? "mr-[0px] lg:text-base xl:text-lg xlarge:text-xl"
                      : "sm:mr-[29px] lg:text-base xl:text-lg xlarge:text-xl"
                  }`}
                >
                  {event?.event?.title === "no_show" ? "No Show" : "Completed"}
                </p>
              </div>
            )}
          </div>
        </>
      ) : event.event.title === "blocked" ? (
        <div
          id="open-block-event-container"
          style={{ border: `1.5px solid ${borderColor}` }}
        >
          <p className="sm:ml-[29px] md:text-sm lg:text-base xl:text-lg xlarge:text-xl">
            {event.event.title == "blocked" && "Blocked"}
          </p>

          {sm ? (
            <div>
              <span onClick={() => handleUnBlock(event?.event)}>
                <img
                  style={{ width: "1.2rem" }}
                  src={Appointment_Icons["unblock"]}
                />
              </span>
            </div>
          ) : (
            <>
              <div
                style={{
                  marginLeft: "auto",
                  width: "fit-content",
                }}
                className="icons sm:mr-[29px]"
              >
                <span onClick={() => handleUnBlock(event?.event)}>
                  <img
                    style={{ width: "1.2rem" }}
                    src={Appointment_Icons["unblock"]}
                  />
                </span>
              </div>
            </>
          )}
        </div>
      ) : (
        <div
          className="custom-event-container"
          style={{ border: `1.5px solid ${borderColor}` }}
        >
          <div
            className={`user-details ${
              event?.event?.clinic_id === clinic_id ? "" : "opacity-50"
            }`}
          >
            {dayCycle == "week" && sm ? (
              <img onClick={() => openModal(event)} src={user_status}></img>
            ) : dayCycle == "week" ? (
              <img onClick={() => openModal(event)} src={user_status}></img>
            ) : (
              <img src={user_status}></img>
            )}
            {dayCycle == "day" && sm ? (
              <h4
                onClick={() => openModal(event)}
                className="md:text-base 2xl:text-lg"
              >
                {event?.event?.user_details?.full_name}
              </h4>
            ) : (
              <>
                <h4 className="md:text-base 2xl:text-lg flex-1">
                  {event?.event?.user_details?.full_name}
                </h4>

                <span className="flex items-center gap-1">
                  {(event?.event?.visit_count !== 0 ||
                    event?.event?.visit_gap?.day !== 0) && (
                    <IoEllipse color="#878787" size={8} />
                  )}
                  <span className="text-[#878787]">{`${getOrdinalSuffix(
                    event?.event?.visit_count
                  )} ${
                    event?.event?.visit_gap?.day === 0
                      ? ""
                      : `(${event?.event?.visit_gap?.day} d)`
                  }`}</span>
                </span>
              </>
            )}
            {sm ? (
              <span>
                <a href={`tel:${event?.event?.user_details?.phone}`}>
                  <span>{eventIcons?.call} </span>
                </a>
              </span>
            ) : (
              <Popup
                inverted
                trigger={
                  <span onClick={() => handleEditPatient(event?.event)}>
                    <img
                      style={{ width: "15px" }}
                      src="https://cufront-assets.s3.amazonaws.com/icons+/Vector.png"
                    />
                  </span>
                }
                position="top center"
                on="hover"
                contentStyle={{
                  padding: "8px 15px",
                  border: "none",
                  width: "fit-content",
                  backgroundColor: "black",
                  color: "white",
                }}
                arrowStyle={{ color: "black" }}
                arrow={true}
              >
                <div>Edit Details</div>
              </Popup>
            )}
            <span className="md:text-base lg:text-base 2xl:text-lg">
              {event?.event?.user_details?.age}
            </span>
            <span className="md:text-base lg:text-base 2xl:text-lg">
              {event?.event?.user_details?.gender?.length > 0
                ? event?.event?.user_details?.gender[0]
                : ""}
            </span>{" "}
          </div>
          {!sm && (
            <div className="flex-1">
              {event.event.is_walk_in ? (
                <p className="text-lg md:text-base lg:text-lg xlarge:text-xl">
                  In-person
                </p>
              ) : (
                <p
                  className="lg:text-sm xl:text-base xlarge:text-lg"
                  style={{ color: "rgba(175, 113, 255, 1)" }}
                >
                  Online
                </p>
              )}
            </div>
          )}
          {!sm && (
            <div className="icons">
              {checkPermission(permission?.allowed_features, 1005) && (
                <Popup
                  trigger={
                    <span
                      className="lg:text-sm xl:text-base xlarge:text-lg"
                      onClick={() => handlePreConsultation(event?.event)}
                    >
                      {event?.event?.preconsultation
                        ? eventIcons?.preConsultationDone
                        : eventIcons?.preConsultation}
                    </span>
                  }
                  position="top center"
                  on="hover"
                  contentStyle={{
                    padding: "8px 15px",
                    border: "none",
                    width: "fit-content",
                    backgroundColor: "black",
                    color: "white",
                  }}
                  arrowStyle={{ color: "black" }}
                  arrow={true}
                >
                  <div>Start Pre-Consultation</div>
                </Popup>
              )}
              <Popup
                trigger={
                  <span
                    className="lg:text-sm xl:text-base xlarge:text-lg"
                    onClick={() => handleStartConsultation(event?.event)}
                  >
                    {isConsultationLoading ? (
                      <CuSpinner />
                    ) : (
                      eventIcons?.startConsultation
                    )}
                  </span>
                }
                position="top center"
                on="hover"
                contentStyle={{
                  padding: "8px 15px",
                  border: "none",
                  width: "fit-content",
                  backgroundColor: "black",
                  color: "white",
                }}
                arrowStyle={{ color: "black" }}
                arrow={true}
              >
                <div>Start Consultation</div>
              </Popup>
              {checkPermission(permission?.allowed_features, 1005) && (
                <Popup
                  trigger={
                    <span
                      className="lg:text-sm xl:text-base xlarge:text-lg"
                      onClick={() => handleEndConsultation(event?.event)}
                    >
                      {isConsultationLoading ? (
                        <CuSpinner />
                      ) : (
                        eventIcons?.endConsultation
                      )}
                    </span>
                  }
                  position="top center"
                  on="hover"
                  contentStyle={{
                    padding: "8px 15px",
                    border: "none",
                    width: "fit-content",
                    backgroundColor: "black",
                    color: "white",
                  }}
                  arrowStyle={{ color: "black" }}
                  arrow={true}
                >
                  <div>End Consultation</div>
                </Popup>
              )}
              <Popup
                trigger={
                  <span
                    className="lg:text-sm xl:text-base xlarge:text-lg"
                    onClick={() =>
                      handleMainSearch(event?.event?.user_details?.id)
                    }
                  >
                    {eventIcons?.viewProfile}{" "}
                  </span>
                }
                position="top center"
                on="hover"
                contentStyle={{
                  padding: "8px 15px",
                  border: "none",
                  width: "fit-content",
                  backgroundColor: "black",
                  color: "white",
                }}
                arrowStyle={{ color: "black" }}
                arrow={true}
              >
                <div>View Profile</div>
              </Popup>
              <Popup
                trigger={
                  <span
                    className="lg:text-sm xl:text-base xlarge:text-lg"
                    onClick={() => handleReschedule(event?.event)}
                  >
                    {eventIcons?.reshedule}{" "}
                  </span>
                }
                position="top center"
                on="hover"
                contentStyle={{
                  padding: "8px 15px",
                  border: "none",
                  width: "fit-content",
                  backgroundColor: "black",
                  color: "white",
                }}
                arrowStyle={{ color: "black" }}
                arrow={true}
              >
                <div>Reschedule</div>
              </Popup>
              {/* {event?.event?.billing_status?.id ? (
              <Popup
                trigger={
                  <span
                    onClick={() =>
                      handleCreateInvoice(
                        event?.event?.billing_status?.bill_type,
                        event?.event
                      )
                    }
                  >
                    <img src={invoice_icon} width="15px" height="16px" />
                  </span>
                }
                position="top center"
                on="hover"
                contentStyle={{
                  width: "fit-content",
                }}
                arrowStyle={{ color: "white" }}
                arrow={true}
              >
                <span>{invoiceTip}</span>
              </Popup>
            ) : (
              <Popup
                trigger={
                  <span>
                    <img src={invoice_icon} width="12.5px" height="15.5px" />
                  </span>
                }
                position="top center"
                on="hover"
                contentStyle={{
                  width: "fit-content",
                }}
                arrowStyle={{ color: "white" }}
                arrow={true}
              >
                <div>
                  <div
                    className="cursor-pointer hover:bg-gray-200 p-1"
                    onClick={() => handleCreateInvoice("IPD", event?.event)}
                  >
                    Create IPD
                  </div>
                  <div
                    className="cursor-pointer hover:bg-gray-200 p-1"
                    onClick={() => handleCreateInvoice("OPD", event?.event)}
                  >
                    Create OPD
                  </div>
                </div>
              </Popup>
            )} */}
              <Popup
                trigger={
                  <span
                    onClick={() => handleCreateInvoice("OPD", event?.event)}
                  >
                    <img src={invoice_icon} width="15px" height="16px" />
                  </span>
                }
                position="top center"
                on="hover"
                contentStyle={{
                  width: "fit-content",
                  backgroundColor: "black",
                  color: "white",
                }}
                arrowStyle={{ color: "black" }}
                arrow={true}
              >
                <span>{invoiceTip}</span>
              </Popup>
              <Popup
                trigger={
                  <span
                    className="lg:text-sm xl:text-base xlarge:text-lg"
                    onClick={() => handleDecline(event?.event)}
                  >
                    {eventIcons?.decline}{" "}
                  </span>
                }
                position="top center"
                on="hover"
                contentStyle={{
                  padding: "8px 15px",
                  border: "none",
                  width: "fit-content",
                  backgroundColor: "black",
                  color: "white",
                }}
                arrowStyle={{ color: "black" }}
                arrow={true}
              >
                <div>Decline</div>
              </Popup>
              <Popup
                trigger={
                  <span className="lg:text-sm xl:text-base xlarge:text-lg">
                    <a
                      href={`tel:${event?.event?.user_details?.phone}`}
                      className=""
                    >
                      {eventIcons?.call}
                    </a>
                  </span>
                }
                position="top center"
                on="hover"
                contentStyle={{
                  padding: "10px 15px",
                  border: "none",
                  width: "fit-content",
                  backgroundColor: "black",
                  color: "white",
                }}
                arrowStyle={{ color: "black" }}
                arrow={true}
              >
                <div>Call Patient</div>
              </Popup>
              <Popup
                trigger={
                  <span
                    className="lg:text-sm xl:text-base xlarge:text-lg"
                    onClick={() => handleNoShow(event?.event)}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {eventIcons?.noShow}
                  </span>
                }
                position="top center"
                on="hover"
                contentStyle={{
                  padding: "8px 10px",
                  border: "none",
                  width: "fit-content",
                  backgroundColor: "black",
                  color: "white",
                }}
                arrowStyle={{ color: "black" }}
                arrow={true}
              >
                <div>No Show</div>
              </Popup>
            </div>
          )}
        </div>
      )}
    </>
  );
});

export default Events;
